module.exports = __webpack_public_path__ + "img/as_con4_img.960943c4.png";